import Repository from "../Repository";
import Utils from "../Utils";

const resource = "/service.php/management";
export default {
    getDashboard() {
        return Repository.get(`/service.php/home/openDashboard${Utils.appendCorsParam()}`, {withCredentials: true});
    },
    getPublisher() {
        return Repository.get(`${resource}/getPublisher${Utils.appendCorsParam()}`, {withCredentials: true});
    },
    getDetails(type_id, cancelToken) { //service.php/management/getDetails?type_id=331
        return Repository.get(`${resource}/getDetails${Utils.appendCorsParam()}&type_id=${type_id}`, {
            cancelToken: cancelToken,
            withCredentials: true
        });
    },
    getSites(id, isVideo) {
        return Repository.get(`${resource}/getSites${Utils.appendCorsParam()}&publisher_id=${id}&isVideo=${isVideo ? 1 : 0}&isDisplay=${isVideo ? 0 : 1}`, {withCredentials: true});
    },
    getSiteDetails(site_id, cancelToken) {
        return Repository.get(`${resource}/getTypesAndDetails${Utils.appendCorsParam()}&site_id=${site_id}`, {
            withCredentials: true,
            cancelToken: cancelToken
        });
    },
    getZoneDetails(id) { ///service.php/management/getZoneDetails?zone_id=7232
        return Repository.get(`${resource}/getZoneDetails${Utils.appendCorsParam()}&zone_id=${id}`, {withCredentials: true});
    },
    getSitesAndTypes(id) { //https://adcontrol.adalliance.io/api/service.php/management/getSitesAndTypes?publisher_id=2
        return Repository.get(`${resource}/getSitesAndTypes${Utils.appendCorsParam()}&publisher_id=${id}`, {withCredentials: true});
    },
    getLogs(id) { //https://adcontrol.adalliance.io/api/service.php/management/getLogsByTypes?sitetype_id=331
        return Repository.get(`${resource}/getLogsByTypes${Utils.appendCorsParam()}&sitetype_id=${id}`, {withCredentials: true});
    },
    getModuleDetails(publisher_id, site_id, type_id, module_id) { //service.php/management/getModuleDetails?publisher_id=2&site_id=240&type_id=331&module_id=3
        return Repository.get(`${resource}/getModuleDetails${Utils.appendCorsParam()}&publisher_id=${publisher_id}&site_id=${site_id}&type_id=${type_id}&module_id=${module_id}`, {withCredentials: true});
    },
    createSite(json) { //https://adcontrol.adalliance.io/api/service.php/management/createSite
        return Repository.post(`${resource}/createSite${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    editSite(json) { //https://adcontrol.adalliance.io/api/service.php/management/editSite
        return Repository.post(`${resource}/editSite${Utils.appendCorsParam()}&isDisplay=${json.isDisplay}&isVideo=${json.isVideo}`, Utils.toFormData(json), {withCredentials: true});
    },
    copySite(json) { //https://adcontrol.adalliance.io/api/service.php/management/copySite
        return Repository.post(`${resource}/copySite${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteSite(json) { //https://adcontrol.adalliance.io/api/service.php/management/copySite
        return Repository.post(`${resource}/deleteSite${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    copySitetype(json) { //https://adcontrol.adalliance.io/api/service.php/management/copySitetype
        return Repository.post(`${resource}/copyType${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    createSitetype(json) { //https://adcontrol.adalliance.io/api/service.php/management/createType
        return Repository.post(`${resource}/createType${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteSitetype(json) { //https://adcontrol.adalliance.io/api/service.php/management/deleteType
        return Repository.post(`${resource}/deleteType${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    createZone(json, cancelToken) { //https://adcontrol.adalliance.io/api/service.php/management/saveZone
        return Repository.post(`${resource}/saveZone${Utils.appendCorsParam()}`, Utils.toFormData(json), {
            withCredentials: true,
            cancelToken: cancelToken
        });
    },
    deleteZone(json, cancelToken) { //https://adcontrol.adalliance.io/api/service.php/management/deleteZone
        return Repository.post(`${resource}/deleteZone${Utils.appendCorsParam()}`, Utils.toFormData(json), {
            withCredentials: true,
            cancelToken: cancelToken
        });
    },
    getPositions(json) {
        return Repository.post(`${resource}/getPositions${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    createPosition(json, cancelToken) {
        return Repository.post(`${resource}/createPosition${Utils.appendCorsParam()}`, Utils.toFormData(json), {
            cancelToken: cancelToken,
            withCredentials: true
        });
    },
    editPosition(json, cancelToken) {
        return Repository.post(`${resource}/editPosition${Utils.appendCorsParam()}`, Utils.toFormData(json), {
            withCredentials: true,
            cancelToken: cancelToken
        });
    },
    savePositionToAll(json) {
        return Repository.post(`${resource}/savePositionToAll${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deletePosition(json, cancelToken) {
        return Repository.post(`${resource}/deletePosition${Utils.appendCorsParam()}`, Utils.toFormData(json), {
            withCredentials: true,
            cancelToken: cancelToken
        });
    },
    saveManagement(json) {
        return Repository.post(`${resource}/saveManagement${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    editDomain(json) {
        return Repository.post(`${resource}/editDomain${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteDomain(json) {
        return Repository.post(`${resource}/deleteDomain${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    editURL(json) {
        return Repository.post(`${resource}/editURL${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteURL(json) {
        return Repository.post(`${resource}/deleteURL${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    openIncludeWindow(id) {
        return Repository.post(`${resource}/openIncludeWindow${Utils.appendCorsParam()}${id ? '&sitetype_include_id=' + id : ''}`, {withCredentials: true});
    },
    saveInclude(json) {
        return Repository.post(`${resource}/saveInclude${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteInclude(json) {
        return Repository.post(`${resource}/deleteInclude${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deployPreview(json) {
        return Repository.post(`${resource}/deployPreview${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deployLive(json) {
        return Repository.post(`${resource}/deployLive${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    getTypesForEmergency(id) {
        return Repository.get(`${resource}/getTypesForEmergency${Utils.appendCorsParam()}&site_id=${id}`, {withCredentials: true});
    },
    saveEmergency(json) {
        return Repository.post(`${resource}/saveEmergency${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    saveEmergencyConfig(json) {
        return Repository.post(`${resource}/saveEmergencyConfig${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    siteStatus(id, override, type) {
        return Repository.get(`${resource}/siteStatus${Utils.appendCorsParam()}&site_id=${id}${override ? '&override=1' : ''}${type ? '&type=' + type : ''}`, {withCredentials: true});
    },
    getUsers() { //https://adcontrol.adalliance.io/api/service.php/user/overview?publisher_id
        return Repository.get(`service.php/user/overview${Utils.appendCorsParam()}&publisher_id=`, {withCredentials: true});
    },
    getUserDetails(id) {
        return Repository.get(`service.php/user/getUserDetails${Utils.appendCorsParam()}&user_id=${id}`, {withCredentials: true});
    },
    editUser(json) {
        return Repository.post(`service.php/user/editUser${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    deleteUser(json) {
        return Repository.post(`service.php/user/deleteUser${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
    getVideo(siteId) {
        return Repository.get(`service.php/video/getBySiteId${Utils.appendCorsParam()}&site_id=${siteId}`, {withCredentials: true});
    },
    editVideo(id, json) {
        return Repository.post(`service.php/video/edit${Utils.appendCorsParam()}&site_id=${id}`, Utils.toFormData(json), {withCredentials: true});
    },
    deployVideo(id, json) {
        return Repository.post(`service.php/video/deploy${Utils.appendCorsParam()}&site_id=${id}`, Utils.toFormData(json), {withCredentials: true});
    },
    resetPosition(json) {
        return Repository.post(`${resource}/resetPosition${Utils.appendCorsParam()}`, Utils.toFormData(json), {withCredentials: true});
    },
}